import { render } from "./BatchUploadAddUsers.vue?vue&type=template&id=4e951d0e"
import script from "./BatchUploadAddUsers.vue?vue&type=script&lang=js"
export * from "./BatchUploadAddUsers.vue?vue&type=script&lang=js"
script.render = render

export default script